import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { DndProvider } from 'react-dnd'
import { Formik, Form, Field } from 'formik'
import HTML5Backend from 'react-dnd-html5-backend'
import { useSelector, useDispatch } from 'react-redux'
import { useModal } from 'react-modal-hook'
import { Row, Col } from 'react-bootstrap'
import NeoButton from '../../../components/NeoButton/NeoButton'
import Loading from 'custom/assets/loaders/Loading'
import './beneficiary.css'
import Modal from '../../../components/Modal/Modal'
import BeneIcon from 'custom/assets/common-icons/bene-image.svg'
import PlusIcon from 'custom/assets/common-icons/plus.svg'
import BeneficiaryDropTarget from '../../../components/BeneficiaryDropTarget/BeneficiaryDropTarget'
import BeneficiaryGridItem from '../../../components/BeneficiaryGridItem/BeneficiaryGridItem'
import LayoutWithAccountCard from '../../Layout/layout-account-card'
import BeneficiaryService from '../../../services/beneficiary.service'
import {
  getAccountListSelector,
  getCurrentAccDetailsSelector,
} from '../../../store/selectors/app.selector'
import { useTranslation } from 'react-i18next'
import { BENEFICIARY_TRANSFER_KEYS, BUTTON_KEYS, BENEFICIARY_VIEW_KEYS } from '../../../utils/translation-constants'
import envConfig from 'custom/config/environment'


export default function BeneficiaryTransfer() {
  const history = useHistory()
  const [stage, setStage] = useState(1)
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [internalBeneList, setInternalBeneList] = useState([])
  const [otherBeneList, setOtherBeneList] = useState([])
  const [internationalBeneList, setInternationalBeneList] = useState([])
  const accounts = useSelector(getAccountListSelector) || []
  const accountDetails = useSelector(getCurrentAccDetailsSelector) || {}
  const [ownAccountList, setOwnAccountList] = useState([])
  const [searchTerm, setSearchTerm] = useState([])
  const [listOfBen, setListOfBen] = useState()
  const [regionalBeneList, setRegionalBeneList] = useState([])
  const { t } = useTranslation()

  const TABS = {
    INTERNAL: {
      label: t(BENEFICIARY_TRANSFER_KEYS.WITH_IN_BANK),
      stage: 1,
    },
    DOMESTIC: {
      label: t(BENEFICIARY_TRANSFER_KEYS.DOMESTIC),
      stage: 2,
    },
    INTERNATIONAL: {
      label: t(BENEFICIARY_TRANSFER_KEYS.INTERNATIONAL),
      stage: 3,
    },
    OWN: {
      label: t(BENEFICIARY_TRANSFER_KEYS.MY_ACCOUNTS),
      stage: 4,
    },
    REGION: {
      label: t(BENEFICIARY_TRANSFER_KEYS.REGIONAL),
      stage: 5,
    },
  }

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6 className='text-center'>{message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  useEffect(() => {
    fetchOwnAccounts()
  }, [accountDetails])

  useEffect(() => {
    fetchBeneficiaries()
    fetchOwnAccounts()
  }, [])

  const fetchOwnAccounts = useCallback(async () => {
    try {
      const accountListCopy = [
        ...accounts.filter((acc) => acc?.accountNo !== accountDetails?.accountNo),
      ]
      setOwnAccountList(accountListCopy)
    } catch (err) {
      setLoading(false)
      setMessage(err.data.message)
      //showModal()
    }
  }, [accounts, accountDetails])

  const fetchBeneficiaries = useCallback(async () => {
    try {
      setLoading(true)
      const response = await BeneficiaryService.getBeneList()
      if (response.status === 200) {
        setListOfBen(response.data)
        setInternalBeneList(response.data['internalBeneList'])
        setInternationalBeneList(
          response.data['otherBankBeneList'].filter((ele) => ele.beneType === 'INTERNATIONAL'),
        )
        setOtherBeneList(
          response.data['otherBankBeneList'].filter((ele) => ele.beneType === 'THIRD_PARTY'),
        )
        setRegionalBeneList(
          response.data['otherBankBeneList'].filter((ele) => ele.beneType === 'REGION'),
        )
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setMessage(err?.data)
      //showModal()
    }
  }, [])

  const handleSearchChange = useCallback(
    (e) => {
      setSearchTerm(e.target.value)
      if (stage === 1) {
        if (e.target.value === '') {
          setInternalBeneList(listOfBen?.internalBeneList)
        } else
          setInternalBeneList(
            listOfBen?.internalBeneList.filter((v) => {
              return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
            }),
          )
      } else if (stage === 2) {
        if (e.target.value === '') {
          setOtherBeneList(
            listOfBen?.otherBankBeneList.filter((ele) => ele.beneType === 'THIRD_PARTY'),
          )
        } else
          setOtherBeneList(
            listOfBen?.otherBankBeneList
              .filter((ele) => ele.beneType === 'THIRD_PARTY')
              .filter((v) => {
                return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
              }),
          )
      } else if (stage === 3) {
        if (e.target.value === '') {
          setInternationalBeneList(
            listOfBen?.otherBankBeneList.filter((ele) => ele.beneType === 'INTERNATIONAL'),
          )
        } else
          setInternationalBeneList(
            listOfBen?.otherBankBeneList
              .filter((ele) => ele.beneType === 'INTERNATIONAL')
              .filter((v) => {
                return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
              }),
          )
      } else if (stage === 4) {
        if (e.target.value === '') {
          setOwnAccountList(ownAccountList)
        } else
          setOwnAccountList(
            ownAccountList.filter((v) => {
              return v.accountNo.toLowerCase().includes(e.target.value.toLowerCase())
            }),
          )
      } else if (stage === 5) {
        if (e.target.value === '') {
          setRegionalBeneList(
            listOfBen?.otherBankBeneList.filter((ele) => ele.beneType === 'REGION'),
          )
        } else
          setRegionalBeneList(
            listOfBen?.otherBankBeneList
              .filter((ele) => ele.beneType === 'REGION')
              .filter((v) => {
                return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
              }),
          )
      }
    },
    [stage, listOfBen],
  )

  useEffect(() => {
    setSearchTerm('')
  }, [stage])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return internalBeneList.map((x, i) => (
          <BeneficiaryGridItem
            transferType='IAT'
            linkPath='/transfers/beneficiary-transfers/internal'
            key={i}
            beneDetails={x}
          />
        ))
      case 2:
        return otherBeneList.map((x, i) => (
          <BeneficiaryGridItem
            transferType='OTHER'
            linkPath='/transfers/beneficiary-transfers/other'
            key={i}
            beneDetails={x}
          />
        ))
      case 3:
        return internationalBeneList.map((x, i) => (
          <BeneficiaryGridItem
            transferType='OTHER'
            linkPath='/transfers/beneficiary-transfers/international'
            key={i}
            beneDetails={x}
          />
        ))

      case 4:
        return ownAccountList.map((x, i) => (
          <BeneficiaryGridItem
            transferType='OAT'
            linkPath='/transfers/beneficiary-transfers/own'
            key={i}
            beneDetails={x}
          />
        ))
      case 5:
        return regionalBeneList.map((x, i) => (
          <BeneficiaryGridItem
            transferType='REGION'
            linkPath='/transfers/beneficiary-transfers/region'
            key={i}
            beneDetails={x}
          />
        ))
      default:
        return internalBeneList.map((x, i) => (
          <BeneficiaryGridItem
            transferType='IAT'
            linkPath='/transfers/beneficiary-transfers/internal'
            key={i}
            beneDetails={x}
          />
        ))
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderGridView() {
    return (
      <>
        <DndProvider backend={HTML5Backend}>
          <div className='row'>
            <div className='col-6'>
              <Row>
                {stage === 1 && (
                  <Col
                    xs={'auto'}
                    sm={'auto'}
                    md={'auto'}
                    onClick={() => history.push('/transfers/add-beneficiary/internal')}
                    className='bene-card'>
                    <img width={30} height={30} src={PlusIcon} />
                    <span style={{ color: 'var(--secondary_1)' }}>{t(BENEFICIARY_VIEW_KEYS.ADD_NEW)}</span>
                  </Col>
                )}
                {stage === 2 && (
                  <Col
                    xs={'auto'}
                    sm={'auto'}
                    md={'auto'}
                    onClick={() => history.push('/transfers/add-beneficiary/domestic')}
                    className='bene-card'>
                    <img width={30} height={30} src={PlusIcon} />
                    <span style={{ color: 'var(--secondary_1)' }}>{t(BENEFICIARY_VIEW_KEYS.ADD_NEW)}</span>
                  </Col>
                )}
                {stage === 4 && ownAccountList.length === 0 && (
                  <div style={{ margin: '0 auto', marginTop: 30 }} className='no-data-found'>
                    {t(BENEFICIARY_TRANSFER_KEYS.NO_ACCOUNTS)}{' '}
                  </div>
                )}
                {renderSwitch().slice(0, 5)}
              </Row>
            </div>
            <div className='col-6'>
              <BeneficiaryDropTarget />
            </div>
            <Row className='m-0'>
              {renderSwitch().slice(5)}
            </Row>
          </div>
        </DndProvider>
      </>
    )
  }



  return (
    <LayoutWithAccountCard breadCumKey='BENE_TRANSFER'>
      <div className='view-beneficiary-list'>
        <h4>{t(BENEFICIARY_TRANSFER_KEYS.HEADER)}</h4>
        <div className='row d-flex justify-content-between bene-navbar'>
          {envConfig.BENEFICIARY_TRANSFER_TABS.map((option, index) => (
            <div
              key={index}
              className={
                stage === TABS[option]['stage']
                  ? `col-${12 / envConfig.BENEFICIARY_TRANSFER_TABS.length} selected`
                  : `col-${12 / envConfig.BENEFICIARY_TRANSFER_TABS.length}`
              }>
              <span onClick={() => setStage(TABS[option]['stage'])}>{TABS[option]['label']}</span>
            </div>
          ))}
          {/* <div className={stage === 1 ? 'col-3 selected' : 'col-3'}>
            <span onClick={() => setStage(1)}>{t(BENEFICIARY_TRANSFER_KEYS.WITH_IN_BANK)}</span>
          </div>
          <div className={stage === 2 ? 'col-3 selected' : 'col-3'}>
            <span onClick={() => setStage(2)}>{t(BENEFICIARY_TRANSFER_KEYS.DOMESTIC)}</span>
          </div>
          <div className={stage === 3 ? 'col-3 selected' : 'col-3'}>
            <span onClick={() => setStage(3)}>{t(BENEFICIARY_TRANSFER_KEYS.INTERNATIONAL)}</span>
          </div>
          <div className={stage === 4 ? 'col-3 selected' : 'col-3'}>
            <span onClick={() => setStage(4)}>{t(BENEFICIARY_TRANSFER_KEYS.MY_ACCOUNTS)}</span>
          </div> */}
        </div>
        <div className='mb-3 '>
          <input
            className='col-12 search-box'
            name='search'
            placeholder={t(BENEFICIARY_TRANSFER_KEYS.SEARCH)}
            type='search'
            onChange={handleSearchChange}
            value={searchTerm}
          // style={{
          //   borderRadius: '10px',
          //   borderStyle: 'solid',
          //   borderColor: 'coral',
          //   outline: 'none',
          // }}
          />
        </div>
      </div>
      {loading && renderLoading()}
      <div style={{ position: 'relative' }}>{!loading && renderGridView()}</div>
    </LayoutWithAccountCard>
  )
}
